import React, {Component} from 'react';
import {toastr} from 'react-redux-toastr';
import Plus from 'react-feather/dist/icons/plus.js';
import { startOfDay, format } from 'date-fns';
import {TabContent, TabPane} from "reactstrap";

import conf from "../../../../conf.js";
import {generate} from "../../../../routes";
import api from '../../../../../api.js';
import connectModal from '../../../../../shared/components/Modals/connect.js';
import MustBeAdmin from '../../../../components/Must/MustBeAdmin.jsx';

import Notes from '../../../../components/Notes/Notes.jsx';
import CommentsModal from '../../../../components/Modals/CommentsModal/CommentsModal.jsx';
import SubmitButton from '../../../../components/Forms/AdminFreelanceMonitorForm/SubmitButton.jsx';
import AdminFreelanceMonitorForm
  from '../../../../components/Forms/AdminFreelanceMonitorForm/AdminFreelanceMonitorForm.jsx';
import Labels from '../../../../components/Freelance/Component/Labels/Labels.jsx';

import {NavTabs} from "../../../../../shared/components/Tabs/NavTabs.jsx";
import {InterviewNote} from "../../../../../shared/components/InterviewNote/InterviewNote.jsx";
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx";
import DivCenterAlign from "../../../../../shared/components/Styled/DivCenterAlign.jsx";

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService';
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService';

import './Monitor.scss';
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

const TABS = {
  COMMENTARY: 'commentary',
  INTERVIEW_COMMENTARY: 'interview_commentary',
}
export class Monitor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notes: [],
      currentTab: TABS.INTERVIEW_COMMENTARY
    };
    this.hasInterviewInitialData = this.props.freelance && !!this.props.freelance.initial_interview_data
  }

  componentDidUpdate = async (prevProps, prevState, prevContext) => {
    if (prevProps.freelance.id !== this.props.freelance.id) {
      await this.loadComments();
    }
  }

  componentDidMount = async () => {
    await this.loadComments();
  }

  onFormSuccess = async () => {
    await this.loadComments();
    toastr.success('Le commentaire a été correctement ajouté');
  };

  onDelete = async (id) => {
    try {
      const result = await api.freelances.notes.remove({
        freelance: this.props.freelance.id,
        note: id,
      });
      await this.loadComments();
      return result;
    } catch (e) {
      console.warn(e);
    }
  };

  addComment = () => {
    this.props.openCommentsModal({
      freelance: this.props.freelance,
      onFormSuccess: this.onFormSuccess,
    });
  };

  onEdit = async (values) => {
    this.props.openCommentsModal({
      freelance: this.props.freelance,
      onFormSuccess: this.onFormSuccess,
      comment: values,
    });
  };

  loadComments = async () => {
    try {
      const notes = (await api.freelances.notes.getAll({
        freelance: this.props.freelance.id,
      })).data;
      this.setState({
        notes,
      });
    } catch (e) {
      console.warn(e);
    }
  };

  editInterviewForm = (values) => {
    const { match, location, link } = this.props;
    const rootPath = link.menu ? link.menu : 'search.view'

    const generatedLink = generate({
      name: `${rootPath}.interview`,
      parameters: match.params,
      search: location.search
    })

    this.props.history.push(generatedLink)
  }

  setCurrentTab = (tab) => {
    this.setState({currentTab: tab})
  }
  render() {
    const {user, freelance} = this.props;
    const {notes = []} = this.state;

    return (
      <FreelancePage>
        <div className="bg-white py-4 px-1 px-lg-5">
          <h2 className="text-center">Suivi {user?.fullname ?? ''}</h2>
          <Labels freelance={freelance} user={user} className="mb-3"/>
          <AdminFreelanceMonitorForm
            keepDirtyOnReinitialize={false}
            enableReinitialize={true}
            onSubmit={this.props.submitUserFreelance}
            isReviewed={freelance?.is_reviewed}
            currentRegistrationStep={freelance?.current_registration_step ?? null}
            hasStoppedSms={user?.alert_offers[0].stop_sms}
            hasSkillsFileUploaded={!!freelance?.skills_file}
            initialValues={{
              user: prepareUserBeforeSubmit(user),
              freelance: {
                ...prepareFreelanceBeforeSubmit(freelance),
                date_cdi_start: freelance.date_cdi_start || format(startOfDay(new Date()), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
              }
            }}
          />
          <div className="col-md-12 mt-3 d-flex">
            <SubmitButton className="mx-auto btn btn-primary">Sauvegarder</SubmitButton>
          </div>
        </div>

        <div className="bg-white py-4 px-1 px-lg-5">
          <div className="position-relative">
            <h2 className="text-center">Commentaires</h2>
            <p className="text-center mb-0">
              Commentaires internes Twineeds, visibles par tout utilisateur ayant un profil de type administrateur + DO.
            </p>
          </div>
        </div>

        <NavTabs navItems={[
          {
            onClick: () => this.setCurrentTab(TABS.INTERVIEW_COMMENTARY),
            isActive: this.state.currentTab === TABS.INTERVIEW_COMMENTARY,
            text: `Commentaires d'entretien`,
          },
          {
            onClick: () => this.setCurrentTab(TABS.COMMENTARY),
            isActive: this.state.currentTab === TABS.COMMENTARY,
            text: `Commentaires (${notes.length})`
          },
        ]}/>

        <TabContent activeTab={this.state.currentTab}>
          <TabPane tabId={TABS.INTERVIEW_COMMENTARY}>

            {(!this.hasInterviewInitialData || (this.hasInterviewInitialData && !this.props.freelance.interview_process_finished)) && (
              <DivCenterAlign className={'mt-4'}>
                <PrimaryButton onClick={this.editInterviewForm}>
                  <Plus/> {this.hasInterviewInitialData ? `Editer le` : `Créer un`}  formulaire d'entretien
                </PrimaryButton>
              </DivCenterAlign>
            )}

            {!this.hasInterviewInitialData ?
              <DivCenterAlign className={'mt-4'}>
                <div className="my-4 font-italic">Aucun commentaire d'entretien</div>
              </DivCenterAlign>
              : <InterviewNote conf={conf} user={user} freelance={freelance} />
            }

          </TabPane>
          <TabPane tabId={TABS.COMMENTARY}>
            <DivCenterAlign className={'mt-4'}>
              <PrimaryButton onClick={this.addComment}><Plus/> Ajouter un commentaire</PrimaryButton>
            </DivCenterAlign>
            <Notes
              onDelete={this.onDelete}
              onEdit={this.onEdit}
              notes={this.state.notes}
            />
          </TabPane>
        </TabContent>
      </FreelancePage>
    );
  }
}

export default connectModal({CommentsModal}, MustBeAdmin(Monitor));
